/* eslint-disable consistent-return */
/* eslint-disable no-useless-catch */
import { setLogin } from "../redux/features/auth/actions";
import axiosIntercepter from "./axiosIntercepter"

const apiService = {
  handleUserInfoLogin: async (payload={},dispatch) => {
    try {
      const response = await axiosIntercepter.post('/master/erc_ldaplogging', payload);
      dispatch(setLogin({recentStatus:response.status}))
      return response.data;
    } catch (error) {
      console.log(error);
      dispatch(setLogin({recentStatus: error.response.status}))
    }

  },
  checkCookieAndLogin: async () =>{
    try {
      const response = await axiosIntercepter.get(`home/check_user_loged_in/`)
      return response?.data
    } catch (error) {
      throw error
    }
  },
  handleConcurrentLogin: async (payload = {},dispatch) => {
    try {
      const response = await axiosIntercepter.post('/home/ConcurrentLogin', payload);
      dispatch(setLogin({recentStatus:response.status}))
      return response.data;
    } catch (error) {
      console.log(error);
      dispatch(setLogin({recentStatus: error.response.status}))
    }
  },

  sessionLogout: async (payload = {},dispatch) => {
    try {
      const response = await axiosIntercepter.post('/home/Logout', payload);
      dispatch(setLogin({recentStatus:response.status}))
      return response;
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error; 
    }
  },
  downloadBudgetExcededTemplate : async (payload ={},dispatch) =>{
    try {
        const response = await axiosIntercepter.post(`reports/GetDocumentView`,payload)
        dispatch(setLogin({recentStatus:response.status}))
        return response
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
        throw error; 
    }
  },
  uploadBudgetExceededData : async (payload = {},dispatch) =>{
    try {
      const response = await axiosIntercepter.post(`master/ExceededProjectUpload`,payload)
      dispatch(setLogin({recentStatus:response.status}))
      return response
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  getBudgetExceededData : async (payload={},dispatch) =>{
    try {
      const response = await axiosIntercepter.post(`master/ExceededProjectInsertBck`,payload)
      dispatch(setLogin({recentStatus:response.status}))
      return response
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  CheckBookingDates : async (payload ={},dispatch) => {
    try {
      const response = await axiosIntercepter.post(`/timeBooking/CheckBookingDates`,payload)
      dispatch(setLogin({recentStatus:response.status}))
      return response
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  budgetExceededReport:async (payload={},dispatch) =>{
    try {
      const response = await axiosIntercepter.post(`/reports/BudgetExceededReport`,payload)
      dispatch(setLogin({recentStatus:response.status}))
      return response
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },

  // Menu List LeftNav
    getMenuList: async (payload={},dispatch) => {
    try {
      const response = await axiosIntercepter.post(`master/menu`,payload)
      dispatch(setLogin({recentStatus:response.status}))
      return response?.data
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  // Project Linkage AccessControlForm
  projectLinkage: async (payload={},dispatch) => {
    try {
      const response = await axiosIntercepter.post(`master/ProjectLinkage`,payload)
      return response?.data
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
// Access Control Request Dets AccessControlForm, AdditionalAccess, BookingStatus.js
  AccessControlRequestDets: async (payload={}, dispatch) => {
    try {
      const response = await axiosIntercepter.post(`master/accessControlRequestDets`,payload)
      return response?.data
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  // ProjectLinkageApprove AccessControlForm
  ProjectLinkageApprove: async (payload={},dispatch) => {
    try {
      const response = await axiosIntercepter.post(`master/ProjectLinkageApprove`,payload)
      return response?.data
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  // ProjectLinkageSave AccessControlForm
  ProjectLinkageSave: async (payload={},dispatch) => {
    try {
      const response = await axiosIntercepter.post(`master/ProjectLinkageSave`,payload)   
      return response?.data
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  // Project Linkage search
  projectLinkageSearch: async (payload={},dispatch) => {
    try {
      const response = await axiosIntercepter.post(`master/ProjectLinkageSearch`,payload)
      dispatch(setLogin({recentStatus:response.status}))
      return response?.data
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  // Check Valid Date CalenderJs
  handleCheckValidDate: async (payload={},dispatch) => {
    try {
      const response = await axiosIntercepter.post(`timeBooking/checkValidDate`,payload)
      dispatch(setLogin({recentStatus:response.status}))
      return response?.data
    } catch (error) {
      dispatch(setLogin({recentStatus: error.response.status}))
      throw error
    }
  },
  // Calendar Data CalenderJs
  getCalendarData: async (payload={},dispatch) => {
      try {
        const response = await axiosIntercepter.post(`timeBooking/calendarData`,payload)
        dispatch(setLogin({recentStatus:response.status}))
        return response?.data
      } catch (error) {
        dispatch(setLogin({recentStatus: error.response.status}))
        throw error
      }
    },

// Get PendingApprovalCount LandingPage

getPendingApprovalCount: async (payload={},dispatch) => {
  try {
    const response = await axiosIntercepter.post(`home/PendingApprovalCount`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// Project Linkage Status Count LandingPage
getProjectLinkageStatusCount: async (payload={},dispatch) => {
  try {
    const response = await axiosIntercepter.post(`home/ProjectLinkageStatusCount`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// deptspoc_UnbookedUnreviewed_HRS LandingPage
getUnbookedUnreviewedHRS: async (payload={},dispatch) => {
  try {
    const response = await axiosIntercepter.post(`home/deptspoc_UnbookedUnreviewed_HRS`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// OperativeUnbookedHrs LandingPage
getOperativeUnbookedHrs: async (payload={},dispatch) => {
  try {
    const response = await axiosIntercepter.post(`home/OperativeUnbookedHrs`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
//  ReporteeUnbookedHrsCount LandingPage

getReporteeUnbookedHrsCount: async (payload={},dispatch) => {
  try {
    const response = await axiosIntercepter.post(`home/ReporteeUnbookedHrsCount`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }

},

// AccessAndRoleManagementStatusCount LandingPage

handleAccessAndRoleManagementStatusCount: async (payload={},dispatch) => {
  try {
    const response = await axiosIntercepter.post(`home/AccessAndRoleManagementStatusCount`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// Get Announcements Announcements

getAnnouncements : async (payload ={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`home/GetAnnouncements`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},

// Get Document View Help

getDocumentView: async (payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`reports/GetDocumentView`,payload)
  return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},

// Get Email Details Help

getDynamicEmailDetails : async (payload ={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`home/EmailShowDynamic`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// Additionalaccessapprovalreject AdditinalAccess

Additionalaccessapprovalreject : async(payload ={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/additionalaccessapprovalreject`,payload)
  return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},

// master/additionalaccessapprovalrejectadmin Additional Access

AdditionalAccessApprovalRejectAdmin : async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/additionalaccessapprovalrejectadmin`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// accessControlSupInfo AdditionalAccess
AccessControlSupInfo : async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/accessControlSupInfo`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// additionalnewaccessusersave AdditionalAccess
AdditionalNewAccessUserSave: async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/additionalnewaccessusersave`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// GetAdditionalAccess_RequestDetails RequestViewAdditionalAccess
GetAdditionalAccessRequestDetails: async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/GetAdditionalAccess_RequestDetails`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},

// BookingEfficiencyReport BookingEReport
BookingEfficiencyReport : async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`reports/BookingEfficiencyReport`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// AccessControlnewRequest BookingStatus
AccessControlnewRequest : async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/accessControlnewRequest`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},

// BookingStatusApprove BookingStatus
BookingStatusApprove : async(payload={},dispatch)=>{
  try {
    const response = await axiosIntercepter.post(`master/bookingStatusApprove`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},

// getEmployeeDetails/ BookingStatus
getEmployeeDetails:  async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/getEmployeeDetails/`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// Changes Start for CHG0073013 
LinkageNotificationUpload:  async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/LinkageNotification`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
},
// LinkageNotificationSend LinkageSearch 
LinkageNotificationSend: async(payload={},dispatch) =>{
  try {
    const response = await axiosIntercepter.post(`master/LinkageNotificationMailSend`,payload)
    return response?.data
  } catch (error) {
    dispatch(setLogin({recentStatus: error.response.status}))
    throw error
  }
}
// Changes END for CHG0073013

};

export default apiService;
